/** The production toasts' sonner rich colors (light theme) per toast type. */
const richColors: Record<string, string> = {
  success: "border-[hsl(145,92%,87%)] bg-[hsl(143,85%,96%)] text-[hsl(140,100%,27%)]",
  info: "border-[hsl(221,91%,93%)] bg-[hsl(208,100%,97%)] text-[hsl(210,92%,45%)]",
  warning: "border-[hsl(49,91%,84%)] bg-[hsl(49,100%,97%)] text-[hsl(31,92%,45%)]",
  error: "border-[hsl(359,100%,94%)] bg-[hsl(359,100%,97%)] text-[hsl(360,100%,45%)]",
};

export interface ToastColors {
  /** Classes for the toast card. */
  root?: string;
  /** Classes for the description line. */
  description: string;
  /** Classes for the close button. */
  close?: string;
  /** Whether the action button uses the primary (orange) look. */
  primaryAction: boolean;
}

/**
 * Colors matching the production toasts: typed toasts use sonner's rich colors
 * (description and close button follow the text color), action notifications
 * use the orange-edged card with a primary action, and plain toasts use
 * sonner's gray description.
 */
export function toastColors(type: string | undefined, hasAction: boolean): ToastColors {
  const rich = type ? richColors[type] : undefined;
  if (rich)
    return { root: rich, description: "text-current", close: "text-current", primaryAction: false };
  if (hasAction)
    return { root: "border-primary/30", description: "text-muted-foreground", primaryAction: true };
  return { description: "text-[#3f3f3f]", primaryAction: false };
}
